import { ProductSubTier, ProductTier } from '@sparemin/api-sdk';
import { createSelector } from 'reselect';
import { Discount } from 'blocks/Pricing/constants';
import { SubscriptionPeriod } from 'blocks/Pricing/types';
import {
  discountSelector,
  subscriptionSelector,
} from 'redux/modules/pricing/selectors';
import { planIsCancelled } from './utils';

interface SubscriptionPeriodSelectorProps {
  tier: ProductTier;
  subscriptionPeriod: SubscriptionPeriod;
}

const tierSelector = (_, props: SubscriptionPeriodSelectorProps) => props.tier;

const subscriptionPeriodSelector = (
  _,
  props: SubscriptionPeriodSelectorProps,
) => props.subscriptionPeriod;

export const planCTALabelSelector = createSelector(
  [
    discountSelector,
    tierSelector,
    subscriptionPeriodSelector,
    subscriptionSelector,
  ],
  (discount, tier, subscriptionPeriod, subscription) => {
    if (discount === Discount.BOGO) {
      return subscriptionPeriod === 'monthly'
        ? 'get a free month'
        : 'get a free year';
    }

    const isBasicOrCancelled =
      tier === ProductTier.BASIC &&
      planIsCancelled(ProductTier.BASIC, subscription);

    const isProTrialOrCancelled =
      tier === ProductTier.PRO &&
      (subscription.subtier === ProductSubTier.PRO_TRIAL ||
        planIsCancelled(ProductTier.PRO, subscription));

    const isProGrowOrCancelled =
      tier === ProductTier.PRO &&
      (subscription.subtier === ProductSubTier.PRO_GROW_20251120_MONTHLY ||
        subscription.subtier === ProductSubTier.PRO_GROW_20251120_YEARLY ||
        planIsCancelled(ProductTier.PRO, subscription));

    if (isBasicOrCancelled || isProTrialOrCancelled || isProGrowOrCancelled) {
      return 'keep this plan';
    }

    return 'get started';
  },
);
